// Getters (GET*)
export const REPORT_GET_LOGO = 'REPORT_GET_LOGO';
export const REPORT_GET_REPORTS = 'REPORT_GET_REPORTS';
export const REPORT_GET_STATE = 'REPORT_GET_STATE';
export const REPORT_GET_SUBREPORT_CURRENT_PAGE = 'REPORT_GET_SUBREPORT_CURRENT_PAGE';
export const REPORT_GET_SUBREPORT_PAGES = 'REPORT_GET_SUBREPORT_PAGES';
export const REPORT_GET_SUBTITLE = 'REPORT_GET_SUBTITLE';
export const REPORT_GET_TITLE = 'REPORT_GET_TITLE';

// Mutations (SET*, ADD*, REMOVE*)
// [CONTEXT]_[ACTION]_[PROPERTY]
export const REPORT_SET_STATE = 'REPORT_SET_STATE';
export const REPORT_SET_SUBREPORT_CURRENT_PAGE = 'REPORT_SET_SUBREPORT_CURRENT_PAGE';
export const REPORT_SET_SUBREPORT_PAGES = 'REPORT_SET_SUBREPORT_PAGES';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
// [CONTEXT]_[ACTION]_[PROPERTY]_[STATUS]
export const REPORT_RESET = 'REPORT_RESET';
export const REPORT_UPDATE_DATA = 'REPORT_UPDATE_DATA';
export const REPORT_UPDATE_SUBREPORT_CURRENT_PAGE = 'REPORT_UPDATE_SUBREPORT_CURRENT_PAGE';
export const REPORT_UPDATE_SUBREPORT_PAGES = 'REPORT_UPDATE_SUBREPORT_PAGES';
